module.exports = __webpack_public_path__ + "static/clubs-screenshot-d915ec89a8ceb8fa53954b4b902b65b2.png";